// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ChurnLeadRejection_modalWrapper__w0x0t"};